import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { ShippableProductsReportService } from './../../../../services/seed/reports/shippable-products-report.service';
import { GrowerDealerAuditService } from './../../../../services/seed/reports/grower-dealer-audit.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { CommonService } from './../../../../services/common/common.service';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { CommonDDL } from '../../../../models/CommonDDL';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

const _ = require('lodash');
@Component({
  selector: 'app-shippable-products-report',
  templateUrl: './shippable-products-report.component.html',
  styleUrls: ['./shippable-products-report.component.scss']
})
export class ShippableProductsReportComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;

  // Common
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;

  // Account Dropdown
  ddlAccounts: any;
  accountsLoading = false;
  selectedAccount: any;
  accountNameCityState: any;
  selectedAccountItem: any;
  isAccountSelected = false;

  // Grower Dropdown
  growerList: any[] = [];
  searchCount = 0;
  growerLoading = false;
  selectedGrowerGmk: any;
  growerName: any;

  exportdisabled = true;

  // Filter
  accountId: number;
  selectedValue: string;
  isTextBoxEmpty = true;
  productFilters: any;
  filterValueList = new Array();
  previousSelectedValue: string;
  searchValue = '';
  partialSearchValue = '';
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  // packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  // treatmentMasterList: any = [];
  accountNoList: any = [];
  productLineMasterList: any = [];
  itemNoList: any = [];
  headerSubscription: any;
  fromDateFilter: any;
  toDateFilter: any;
  isEvolveAccountRestriction = false;
  evolveUserId = '';

  filter = <ShippableProductsFilter>{};
  public shipableProductDataSource: MatTableDataSource<any>;
  public shippableProductsList: any = [];

  // comparisonType: any[] = [{ value: '<' }, { value: '>' }, { value: '=' }, { value: '>=' }, { value: '<=' }];
  displayedColumns: string[] = ['shipToAccount', 'accountName', 'city', 'state', 'itemNumber', 'itemDescription', 'desiredDeliveryDate', 'growerOrderUnits', 'productLineDescription', 'marketingBrandDescription', 'brand', 'productCategoryDescription', 'seedSizeDescription', 'softCommitUnits', 'hardCommitUnits', 'totalDealerOrderUnits', 'shippableQuantity'];
  searchTypeList: string[] = ['Product Line', 'Marketing Brand', 'Product Name', 'Technology', 'Seed Size', 'Account No', 'Item Number', 'Desired Delivery Date'];

  constructor(private shippableProductsReportService: ShippableProductsReportService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private growerDealerAuditService: GrowerDealerAuditService) {
  }

  // Set datasource for grid
  setDS(source: any[]) {
    this.shipableProductDataSource = new MatTableDataSource(source);
    this.shipableProductDataSource.paginator = this.productPaginator;
    // if (this.productPaginator) {
    //  this.productPaginator.firstPage();
    // }
    this.shipableProductDataSource.sort = this.productSort;
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.getAccountList();
    this.loadMasterData();
    this.resetAuditFilter();
    this.selectedValue = this.searchTypeList[0];

    this.setDS([]);
    this.getEvolveAccess();
  }

  ngOnDestroy() {
    if (this.headerSubscription) {
      this.headerSubscription.unsubscribe();
    }
  }

  // get Settings
  getEvolveAccess() {
    const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    const sessionData = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    this.filter.evolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.filter.userId = sessionData.userId;
    this.evolveUserId = sessionData.userId;
    this.setFilter();
  }

  setFilter() {
    if (this.isEvolveAccountRestriction) { this.searchTypeList = ['Product Line', 'Marketing Brand', 'Product Name', 'Technology', 'Seed Size', 'Account', 'Item Number', 'Desired Delivery Date']; }
    else { this.searchTypeList = ['Product Line', 'Marketing Brand', 'Product Name', 'Technology', 'Seed Size', 'Account No', 'Account Name', 'Item Number', 'Desired Delivery Date']; }
  }

  // Bind Account list
  getAccountList() {
    this.accountsLoading = true;
    this.growerDealerAuditService.getDealerAuditAccountList().subscribe((result: any[]) => {
      this.ddlAccounts = result;
      this.accountsLoading = false;
    }, error => LolLoggerService.error(error));
  }

  // Enable Disable Search
  enableDisableSearch() {
    if (this.validateFilter(this.productFilters)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Brand Search
  validateBrandSearch() {
    // To Validate Brand
    if (this.productFilters.Brand !== null
      && this.productFilters.Brand !== ''
      && this.productFilters.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // to validate filter
  validateFilter(productFilter) {
    let isValid = false;

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Technology
    if (productFilter.TechnologyList != null && productFilter.TechnologyList.length > 0) {
      isValid = true;
    }

    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.TechnologyList == null || productFilter.TechnologyList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)) {
      isValid = false;
    }

    return isValid;
  }

  validateInputText() {
    const accountRegx = RegExp('^[0-9, ]+$');
    return ((this.productFilters.TxtAccountNo ? accountRegx.test(this.productFilters.TxtAccountNo) : true));
  }

  // Keep Filter Value
  keepFilter(selectedObj: any, type: string) {
    if (!this.validateInputText()) {
      this.toastrService.error('Invalid Input.');
      return false;
    }

    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
      }

      switch (type) {
        case 'MarketingBrand':
          this.filter.marketingBrand = selectedIds;
          break;
        case 'SeedSize':
          this.filter.seedSize = selectedIds;
          break;
        case 'Technology':
          this.filter.technology = selectedIds;
          break;
        case 'ProductLine':
          this.filter.productLine = selectedIds;
          break;
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];

      if (this.productFilters) {
        if (!this.validateInputText()) {
          this.toastrService.error('Invalid Input.');
          return false;
        }

        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
          this.filter.brand = this.productFilters.Brand;
        }
        else {
          this.filter.brand = null;
        }

        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          var strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
          // this.filter.marketingBrand = strMB;
        } else {
          this.filter.marketingBrand = null;
        }

        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
          // this.filter.seedSize = strSS;
        }
        else {
          this.filter.seedSize = null;
        }

        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList.length > 0) {
          let strTech = '';
          this.productFilters.TechnologyList.forEach(x => {
            strTech = strTech + x + ', ';
          });
          this.filterValueList.push('Technology : ' + strTech.substr(0, strTech.length - 2));
          // this.filter.technology = strTech;
        }
        else {
          this.filter.technology = null;
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
          // this.filter.productLine = strPL;
        }
        else {
          this.filter.productLine = null;
        }

        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          var strMB = '';
          this.productFilters.ItemNo.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strMB.substr(0, strMB.length - 2));
        }

        // Set Ship To Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo;
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          selectedIds = '';
          this.accountNoList.forEach(x => {
            if (this.productFilters.AccountNo.indexOf(x.accountNumber) > -1) {
              selectedIds = selectedIds + x.accountNumber + ',';
            }
          });
          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = selectedIds;
          }
        }
        else {
          this.filter.account = null;
        }

        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName;
        }
        else {
          this.filter.accountName = null;
        }

        if (this.productFilters.FromDate
          && this.productFilters.FromDate != null
          && this.productFilters.ToDate
          && this.productFilters.ToDate != null) {
          this.filterValueList.push('Desired Delivery Date : (' + this.datePipe.transform(this.productFilters.FromDate, 'MM-dd-yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToDate, 'MM-dd-yyyy') + ')');
          this.filter.fromDate = new Date(this.productFilters.FromDate).toDateString();
          this.filter.toDate = new Date(this.productFilters.ToDate).toDateString();
        }
      }
    }
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
      (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
      (this.productFilters.TechnologyList && this.productFilters.TechnologyList.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0))
      {
      this.productFilters = this.getProductFilters(this.productFilters);
    }
    this.enableDisableSearch();

    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Get Product filter
  getProductFilters(productFilter) {
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = this.accountId;
    return productFilter;
  }

  // Load master data
  loadMasterData() {
    // Product master data
    // if (this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST)) {
    //  this.productMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST));
    // }

    // get Item Number List
    this.commonService.getItemNumbers().subscribe((result: any) => {
      this.itemNoList = result;
    });
    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    this.commonService.getReportFilterDDLValues(this.headerYear).subscribe(result => {
      const data = result as CommonDDL;
      this.accountNoList = data.accounts;
    }, error => LolLoggerService.error(error));
  }

  // Reset Audit Filter
  resetAuditFilter() {
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'ItemNo': [],
      'Brand': null,
      'TxtAccountNo': null,
      'AccountNo': [],
      'Account': null,
      'AccountName': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'TechnologyList': [],
      'ProductLineList': [],
    };
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeAuditFilter(filterValue);

      if (this.filterValueList.length < 1) {
      }
      this.enableDisableSearch();
    }
  }

  // To remove clear search filter
  removeAuditFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;
      case 'Product Name':
        this.productFilters.Brand = null;
        this.filter.brand = null;
        break;
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        this.filter.marketingBrand = null;
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        this.filter.seedSize = null;
        break;
      case 'Technology':
        this.productFilters.TechnologyList = [];
        this.filter.technology = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        this.filter.productLine = null;
        break;
      case 'Desired Delivery Date':
        this.productFilters.FromDate = null;
        this.productFilters.ToDate = null;
        this.filter.fromDate = null;
        this.filter.toDate = null;
        this.fromDateFilter = '';
        this.toDateFilter = '';
        break;
      case 'EvolveAccountRestriction':
        this.filter.evolveAccountRestriction = null;
        break;
      case 'UserId':
        this.filter.userId = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.isTextBoxEmpty = true;
    this.resetAuditFilter();
    this.validateDateFilter('clearAll', '');
    // To Do clear grid
    this.filter = <ShippableProductsFilter>{};
    this.setDS([]);
    this.exportdisabled = true;
  }

  // Search the account details on Account dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Serach the data in list and get the serach items count
  search($event) {
    let list: any;
    list = _.filter(this.growerList, item => item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf($event) > -1
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf($event) > -1)
      || (item.growerGMK == null ? false : item.growerGMK.toString().indexOf($event) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf($event) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf($event) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf($event) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf($event) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf($event) > -1));
    this.searchCount = list.length;
  }

  // Get shippable products record
  getShippableProductsRecords() {
    if (!this.validateInputText()) {
      this.toastrService.error('Invalid Input.');
      return false;
    }

    this.keepFilter(null, ' ');

    this.filter.evolveAccountRestriction = this.isEvolveAccountRestriction;
    this.filter.userId = this.evolveUserId;

    this.loaderService.setLoaderStatus(true);

    this.shippableProductsReportService.getShippableProductList(this.filter).subscribe((result: any) => {
      if (result) {
        this.shippableProductsList = [];
        this.shippableProductsList = result;

        this.setDS(this.shippableProductsList);
        if (this.productPaginator) {
          this.productPaginator.firstPage();
        }
        this.exportdisabled = false;
      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
      this.exportdisabled = true;
      LolLoggerService.error(error);
    });
  }

  // Export data from grid data
  onExportBtnClick() {
    this.loaderService.setLoaderStatus(true);

    if (this.shippableProductsList && this.shippableProductsList.length > 0) {
      const excelData = [];
      this.shippableProductsList.forEach(x => {
        excelData.push({
          'Account': x.shipToAccount,
          'Account Name': x.accountName,
          'Account City': x.city,
          'Account State': x.state,
          'Item Number': x.itemNumber,
          'Item Description': x.itemDescription,
          'Desired Delivery Date': this.datePipe.transform(x.desiredDeliveryDate, 'MM-dd-yyyy'),
          'Grower Order Units': x.growerOrderUnits,
          'Product Line': x.productLineDescription,
          'Marketing Brand': x.marketingBrandDescription,
          'Product Name': x.brand,
          'Technology': x.productCategoryDescription,
          'Seed Size': x.seedSizeDescription,
          'Soft Commit': x.softCommitUnits,
          'Hard Commit': x.hardCommitUnits,
          'Total Dealer Order': x.totalDealerOrderUnits,
          'Shippable': x.shippableQuantity,
        });
      });

      setTimeout(x => {
        this.excelService.exportExcel(excelData, 'ShippableProducts');
        this.loaderService.setLoaderStatus(false);
      }, 100);
    }
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // Set Account Table Height
  setAccountTableHeight() {
    const tableHeight = window.innerHeight - $('.accountDropDown').outerHeight() - $('.growerDropDown').outerHeight() - $('.productFilterDropDown').outerHeight() - 60;
    $('.tableComponentOuter').css('max-height', tableHeight + 'px');
  }

  validateDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToDate) {
        var toDate = new Date(this.productFilters.ToDate);
        this.fromDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toDate') {
      toDate = new Date($event.value);
      this.fromDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromDate) {
        var fromDate = new Date(this.productFilters.FromDate);
        this.toDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromDateFilter = '';
      this.toDateFilter = '';
    }
  }
}

interface ShippableProductsFilter {
  companyCode: string;
  cropYear: number;
  account: string  // shipTo
  accountName: string;
  itemNo: string;
  brand: string;
  marketingBrand: string;
  seedSize: string;
  technology: string;
  productLine: string;
  fromDate: string;
  toDate: string;
  evolveAccountRestriction: boolean;
  userId: string;
  includeShippableQtyZero: boolean;
}
